// list found here: https://github.com/mackilroy007/font-awesome-v6/blob/main/FA5%20icons%20in%20FA6%20format.js
export const icons = [
	"fa-light fa-abacus",
	"fa-light fa-acorn",
	"fa-light fa-ad",
	"fa-light fa-address-book",
	"fa-light fa-address-card",
	"fa-light fa-adjust",
	"fa-light fa-air-conditioner",
	"fa-light fa-air-freshener",
	"fa-light fa-alarm-clock",
	"fa-light fa-alarm-exclamation",
	"fa-light fa-alarm-plus",
	"fa-light fa-alarm-snooze",
	"fa-light fa-album",
	"fa-light fa-album-collection",
	"fa-light fa-alicorn",
	"fa-light fa-alien",
	"fa-light fa-alien-monster",
	"fa-light fa-align-center",
	"fa-light fa-align-justify",
	"fa-light fa-align-left",
	"fa-light fa-align-right",
	"fa-light fa-align-slash",
	"fa-light fa-allergies",
	"fa-light fa-ambulance",
	"fa-light fa-american-sign-language-interpreting",
	"fa-light fa-amp-guitar",
	"fa-light fa-analytics",
	"fa-light fa-anchor",
	"fa-light fa-angel",
	"fa-light fa-angle-double-down",
	"fa-light fa-angle-double-left",
	"fa-light fa-angle-double-right",
	"fa-light fa-angle-double-up",
	"fa-light fa-angle-down",
	"fa-light fa-angle-left",
	"fa-light fa-angle-right",
	"fa-light fa-angle-up",
	"fa-light fa-angry",
	"fa-light fa-ankh",
	"fa-light fa-apple-alt",
	"fa-light fa-apple-crate",
	"fa-light fa-archive",
	"fa-light fa-archway",
	"fa-light fa-arrow-alt-circle-down",
	"fa-light fa-arrow-alt-circle-left",
	"fa-light fa-arrow-alt-circle-right",
	"fa-light fa-arrow-alt-circle-up",
	"fa-light fa-arrow-alt-down",
	"fa-light fa-arrow-alt-from-bottom",
	"fa-light fa-arrow-alt-from-left",
	"fa-light fa-arrow-alt-from-right",
	"fa-light fa-arrow-alt-from-top",
	"fa-light fa-arrow-alt-left",
	"fa-light fa-arrow-alt-right",
	"fa-light fa-arrow-alt-square-down",
	"fa-light fa-arrow-alt-square-left",
	"fa-light fa-arrow-alt-square-right",
	"fa-light fa-arrow-alt-square-up",
	"fa-light fa-arrow-alt-to-bottom",
	"fa-light fa-arrow-alt-to-left",
	"fa-light fa-arrow-alt-to-right",
	"fa-light fa-arrow-alt-to-top",
	"fa-light fa-arrow-alt-up",
	"fa-light fa-arrow-circle-down",
	"fa-light fa-arrow-circle-left",
	"fa-light fa-arrow-circle-right",
	"fa-light fa-arrow-circle-up",
	"fa-light fa-arrow-down",
	"fa-light fa-arrow-from-bottom",
	"fa-light fa-arrow-from-left",
	"fa-light fa-arrow-from-right",
	"fa-light fa-arrow-from-top",
	"fa-light fa-arrow-left",
	"fa-light fa-arrow-right",
	"fa-light fa-arrow-square-down",
	"fa-light fa-arrow-square-left",
	"fa-light fa-arrow-square-right",
	"fa-light fa-arrow-square-up",
	"fa-light fa-arrow-to-bottom",
	"fa-light fa-arrow-to-left",
	"fa-light fa-arrow-to-right",
	"fa-light fa-arrow-to-top",
	"fa-light fa-arrow-up",
	"fa-light fa-arrows",
	"fa-light fa-arrows-alt",
	"fa-light fa-arrows-alt-h",
	"fa-light fa-arrows-alt-v",
	"fa-light fa-arrows-h",
	"fa-light fa-arrows-v",
	"fa-light fa-assistive-listening-systems",
	"fa-light fa-asterisk",
	"fa-light fa-at",
	"fa-light fa-atlas",
	"fa-light fa-atom",
	"fa-light fa-atom-alt",
	"fa-light fa-audio-description",
	"fa-light fa-award",
	"fa-light fa-axe",
	"fa-light fa-axe-battle",
	"fa-light fa-baby",
	"fa-light fa-baby-carriage",
	"fa-light fa-backpack",
	"fa-light fa-backspace",
	"fa-light fa-backward",
	"fa-light fa-bacon",
	"fa-light fa-bacteria",
	"fa-light fa-bacterium",
	"fa-light fa-badge",
	"fa-light fa-badge-check",
	"fa-light fa-badge-dollar",
	"fa-light fa-badge-percent",
	"fa-light fa-badge-sheriff",
	"fa-light fa-badger-honey",
	"fa-light fa-bags-shopping",
	"fa-light fa-bahai",
	"fa-light fa-balance-scale",
	"fa-light fa-balance-scale-left",
	"fa-light fa-balance-scale-right",
	"fa-light fa-ball-pile",
	"fa-light fa-ballot",
	"fa-light fa-ballot-check",
	"fa-light fa-ban",
	"fa-light fa-band-aid",
	"fa-light fa-banjo",
	"fa-light fa-barcode",
	"fa-light fa-barcode-alt",
	"fa-light fa-barcode-read",
	"fa-light fa-barcode-scan",
	"fa-light fa-bars",
	"fa-light fa-baseball",
	"fa-light fa-baseball-ball",
	"fa-light fa-basketball-ball",
	"fa-light fa-basketball-hoop",
	"fa-light fa-bat",
	"fa-light fa-bath",
	"fa-light fa-battery-bolt",
	"fa-light fa-battery-empty",
	"fa-light fa-battery-full",
	"fa-light fa-battery-half",
	"fa-light fa-battery-quarter",
	"fa-light fa-battery-slash",
	"fa-light fa-battery-three-quarters",
	"fa-light fa-bed",
	"fa-light fa-bed-alt",
	"fa-light fa-bed-bunk",
	"fa-light fa-bed-empty",
	"fa-light fa-beer",
	"fa-light fa-bell",
	"fa-light fa-bell-exclamation",
	"fa-light fa-bell-on",
	"fa-light fa-bell-plus",
	"fa-light fa-bell-school",
	"fa-light fa-bell-school-slash",
	"fa-light fa-bell-slash",
	"fa-light fa-bells",
	"fa-light fa-betamax",
	"fa-light fa-bezier-curve",
	"fa-light fa-bible",
	"fa-light fa-bicycle",
	"fa-light fa-biking",
	"fa-light fa-biking-mountain",
	"fa-light fa-binoculars",
	"fa-light fa-biohazard",
	"fa-light fa-birthday-cake",
	"fa-light fa-blanket",
	"fa-light fa-blender",
	"fa-light fa-blender-phone",
	"fa-light fa-blind",
	"fa-light fa-blinds",
	"fa-light fa-blinds-open",
	"fa-light fa-blinds-raised",
	"fa-light fa-blog",
	"fa-light fa-bold",
	"fa-light fa-bolt",
	"fa-light fa-bomb",
	"fa-light fa-bone",
	"fa-light fa-bone-break",
	"fa-light fa-bong",
	"fa-light fa-book",
	"fa-light fa-book-alt",
	"fa-light fa-book-dead",
	"fa-light fa-book-heart",
	"fa-light fa-book-medical",
	"fa-light fa-book-open",
	"fa-light fa-book-reader",
	"fa-light fa-book-spells",
	"fa-light fa-book-user",
	"fa-light fa-bookmark",
	"fa-light fa-books",
	"fa-light fa-books-medical",
	"fa-light fa-boombox",
	"fa-light fa-boot",
	"fa-light fa-booth-curtain",
	"fa-light fa-border-all",
	"fa-light fa-border-bottom",
	"fa-light fa-border-center-h",
	"fa-light fa-border-center-v",
	"fa-light fa-border-inner",
	"fa-light fa-border-left",
	"fa-light fa-border-none",
	"fa-light fa-border-outer",
	"fa-light fa-border-right",
	"fa-light fa-border-style",
	"fa-light fa-border-style-alt",
	"fa-light fa-border-top",
	"fa-light fa-bow-arrow",
	"fa-light fa-bowling-ball",
	"fa-light fa-bowling-pins",
	"fa-light fa-box",
	"fa-light fa-box-alt",
	"fa-light fa-box-ballot",
	"fa-light fa-box-check",
	"fa-light fa-box-fragile",
	"fa-light fa-box-full",
	"fa-light fa-box-heart",
	"fa-light fa-box-open",
	"fa-light fa-box-tissue",
	"fa-light fa-box-up",
	"fa-light fa-box-usd",
	"fa-light fa-boxes",
	"fa-light fa-boxes-alt",
	"fa-light fa-boxing-glove",
	"fa-light fa-brackets",
	"fa-light fa-brackets-curly",
	"fa-light fa-braille",
	"fa-light fa-brain",
	"fa-light fa-bread-loaf",
	"fa-light fa-bread-slice",
	"fa-light fa-briefcase",
	"fa-light fa-briefcase-medical",
	"fa-light fa-bring-forward",
	"fa-light fa-bring-front",
	"fa-light fa-broadcast-tower",
	"fa-light fa-broom",
	"fa-light fa-browser",
	"fa-light fa-brush",
	"fa-light fa-bug",
	"fa-light fa-building",
	"fa-light fa-bullhorn",
	"fa-light fa-bullseye",
	"fa-light fa-bullseye-arrow",
	"fa-light fa-bullseye-pointer",
	"fa-light fa-burger-soda",
	"fa-light fa-burn",
	"fa-light fa-burrito",
	"fa-light fa-bus",
	"fa-light fa-bus-alt",
	"fa-light fa-bus-school",
	"fa-light fa-business-time",
	"fa-light fa-cabinet-filing",
	"fa-light fa-cactus",
	"fa-light fa-calculator",
	"fa-light fa-calculator-alt",
	"fa-light fa-calendar",
	"fa-light fa-calendar-alt",
	"fa-light fa-calendar-check",
	"fa-light fa-calendar-day",
	"fa-light fa-calendar-edit",
	"fa-light fa-calendar-exclamation",
	"fa-light fa-calendar-minus",
	"fa-light fa-calendar-plus",
	"fa-light fa-calendar-star",
	"fa-light fa-calendar-times",
	"fa-light fa-calendar-week",
	"fa-light fa-camcorder",
	"fa-light fa-camera",
	"fa-light fa-camera-alt",
	"fa-light fa-camera-home",
	"fa-light fa-camera-movie",
	"fa-light fa-camera-polaroid",
	"fa-light fa-camera-retro",
	"fa-light fa-campfire",
	"fa-light fa-campground",
	"fa-light fa-candle-holder",
	"fa-light fa-candy-cane",
	"fa-light fa-candy-corn",
	"fa-light fa-cannabis",
	"fa-light fa-capsules",
	"fa-light fa-car",
	"fa-light fa-car-alt",
	"fa-light fa-car-battery",
	"fa-light fa-car-building",
	"fa-light fa-car-bump",
	"fa-light fa-car-bus",
	"fa-light fa-car-crash",
	"fa-light fa-car-garage",
	"fa-light fa-car-mechanic",
	"fa-light fa-car-side",
	"fa-light fa-car-tilt",
	"fa-light fa-car-wash",
	"fa-light fa-caravan",
	"fa-light fa-caravan-alt",
	"fa-light fa-caret-circle-down",
	"fa-light fa-caret-circle-left",
	"fa-light fa-caret-circle-right",
	"fa-light fa-caret-circle-up",
	"fa-light fa-caret-down",
	"fa-light fa-caret-left",
	"fa-light fa-caret-right",
	"fa-light fa-caret-square-down",
	"fa-light fa-caret-square-left",
	"fa-light fa-caret-square-right",
	"fa-light fa-caret-square-up",
	"fa-light fa-caret-up",
	"fa-light fa-carrot",
	"fa-light fa-cars",
	"fa-light fa-cart-arrow-down",
	"fa-light fa-cart-plus",
	"fa-light fa-cash-register",
	"fa-light fa-cassette-tape",
	"fa-light fa-cat",
	"fa-light fa-cat-space",
	"fa-light fa-cauldron",
	"fa-light fa-cctv",
	"fa-light fa-certificate",
	"fa-light fa-chair",
	"fa-light fa-chair-office",
	"fa-light fa-chalkboard",
	"fa-light fa-chalkboard-teacher",
	"fa-light fa-charging-station",
	"fa-light fa-chart-area",
	"fa-light fa-chart-bar",
	"fa-light fa-chart-line",
	"fa-light fa-chart-line-down",
	"fa-light fa-chart-network",
	"fa-light fa-chart-pie",
	"fa-light fa-chart-pie-alt",
	"fa-light fa-chart-scatter",
	"fa-light fa-check",
	"fa-light fa-check-circle",
	"fa-light fa-check-double",
	"fa-light fa-check-square",
	"fa-light fa-cheese",
	"fa-light fa-cheese-swiss",
	"fa-light fa-cheeseburger",
	"fa-light fa-chess",
	"fa-light fa-chess-bishop",
	"fa-light fa-chess-bishop-alt",
	"fa-light fa-chess-board",
	"fa-light fa-chess-clock",
	"fa-light fa-chess-clock-alt",
	"fa-light fa-chess-king",
	"fa-light fa-chess-king-alt",
	"fa-light fa-chess-knight",
	"fa-light fa-chess-knight-alt",
	"fa-light fa-chess-pawn",
	"fa-light fa-chess-pawn-alt",
	"fa-light fa-chess-queen",
	"fa-light fa-chess-queen-alt",
	"fa-light fa-chess-rook",
	"fa-light fa-chess-rook-alt",
	"fa-light fa-chevron-circle-down",
	"fa-light fa-chevron-circle-left",
	"fa-light fa-chevron-circle-right",
	"fa-light fa-chevron-circle-up",
	"fa-light fa-chevron-double-down",
	"fa-light fa-chevron-double-left",
	"fa-light fa-chevron-double-right",
	"fa-light fa-chevron-double-up",
	"fa-light fa-chevron-down",
	"fa-light fa-chevron-left",
	"fa-light fa-chevron-right",
	"fa-light fa-chevron-square-down",
	"fa-light fa-chevron-square-left",
	"fa-light fa-chevron-square-right",
	"fa-light fa-chevron-square-up",
	"fa-light fa-chevron-up",
	"fa-light fa-child",
	"fa-light fa-chimney",
	"fa-light fa-church",
	"fa-light fa-circle",
	"fa-light fa-circle-notch",
	"fa-light fa-city",
	"fa-light fa-clarinet",
	"fa-light fa-claw-marks",
	"fa-light fa-clinic-medical",
	"fa-light fa-clipboard",
	"fa-light fa-clipboard-check",
	"fa-light fa-clipboard-list",
	"fa-light fa-clipboard-list-check",
	"fa-light fa-clipboard-prescription",
	"fa-light fa-clipboard-user",
	"fa-light fa-clock",
	"fa-light fa-clone",
	"fa-light fa-closed-captioning",
	"fa-light fa-cloud",
	"fa-light fa-cloud-download",
	"fa-light fa-cloud-download-alt",
	"fa-light fa-cloud-drizzle",
	"fa-light fa-cloud-hail",
	"fa-light fa-cloud-hail-mixed",
	"fa-light fa-cloud-meatball",
	"fa-light fa-cloud-moon",
	"fa-light fa-cloud-moon-rain",
	"fa-light fa-cloud-music",
	"fa-light fa-cloud-rain",
	"fa-light fa-cloud-rainbow",
	"fa-light fa-cloud-showers",
	"fa-light fa-cloud-showers-heavy",
	"fa-light fa-cloud-sleet",
	"fa-light fa-cloud-snow",
	"fa-light fa-cloud-sun",
	"fa-light fa-cloud-sun-rain",
	"fa-light fa-cloud-upload",
	"fa-light fa-cloud-upload-alt",
	"fa-light fa-clouds",
	"fa-light fa-clouds-moon",
	"fa-light fa-clouds-sun",
	"fa-light fa-club",
	"fa-light fa-cocktail",
	"fa-light fa-code",
	"fa-light fa-code-branch",
	"fa-light fa-code-commit",
	"fa-light fa-code-merge",
	"fa-light fa-coffee",
	"fa-light fa-coffee-pot",
	"fa-light fa-coffee-togo",
	"fa-light fa-coffin",
	"fa-light fa-coffin-cross",
	"fa-light fa-cog",
	"fa-light fa-cogs",
	"fa-light fa-coin",
	"fa-light fa-coins",
	"fa-light fa-columns",
	"fa-light fa-comet",
	"fa-light fa-comment",
	"fa-light fa-comment-alt",
	"fa-light fa-comment-alt-check",
	"fa-light fa-comment-alt-dollar",
	"fa-light fa-comment-alt-dots",
	"fa-light fa-comment-alt-edit",
	"fa-light fa-comment-alt-exclamation",
	"fa-light fa-comment-alt-lines",
	"fa-light fa-comment-alt-medical",
	"fa-light fa-comment-alt-minus",
	"fa-light fa-comment-alt-music",
	"fa-light fa-comment-alt-plus",
	"fa-light fa-comment-alt-slash",
	"fa-light fa-comment-alt-smile",
	"fa-light fa-comment-alt-times",
	"fa-light fa-comment-check",
	"fa-light fa-comment-dollar",
	"fa-light fa-comment-dots",
	"fa-light fa-comment-edit",
	"fa-light fa-comment-exclamation",
	"fa-light fa-comment-lines",
	"fa-light fa-comment-medical",
	"fa-light fa-comment-minus",
	"fa-light fa-comment-music",
	"fa-light fa-comment-plus",
	"fa-light fa-comment-slash",
	"fa-light fa-comment-smile",
	"fa-light fa-comment-times",
	"fa-light fa-comments",
	"fa-light fa-comments-alt",
	"fa-light fa-comments-alt-dollar",
	"fa-light fa-comments-dollar",
	"fa-light fa-compact-disc",
	"fa-light fa-compass",
	"fa-light fa-compass-slash",
	"fa-light fa-compress",
	"fa-light fa-compress-alt",
	"fa-light fa-compress-arrows-alt",
	"fa-light fa-compress-wide",
	"fa-light fa-computer-classic",
	"fa-light fa-computer-speaker",
	"fa-light fa-concierge-bell",
	"fa-light fa-construction",
	"fa-light fa-container-storage",
	"fa-light fa-conveyor-belt",
	"fa-light fa-conveyor-belt-alt",
	"fa-light fa-cookie",
	"fa-light fa-cookie-bite",
	"fa-light fa-copy",
	"fa-light fa-copyright",
	"fa-light fa-corn",
	"fa-light fa-couch",
	"fa-light fa-cow",
	"fa-light fa-cowbell",
	"fa-light fa-cowbell-more",
	"fa-light fa-credit-card",
	"fa-light fa-credit-card-blank",
	"fa-light fa-credit-card-front",
	"fa-light fa-cricket",
	"fa-light fa-croissant",
	"fa-light fa-crop",
	"fa-light fa-crop-alt",
	"fa-light fa-cross",
	"fa-light fa-crosshairs",
	"fa-light fa-crow",
	"fa-light fa-crown",
	"fa-light fa-crutch",
	"fa-light fa-crutches",
	"fa-light fa-cube",
	"fa-light fa-cubes",
	"fa-light fa-curling",
	"fa-light fa-cut",
	"fa-light fa-dagger",
	"fa-light fa-database",
	"fa-light fa-deaf",
	"fa-light fa-debug",
	"fa-light fa-deer",
	"fa-light fa-deer-rudolph",
	"fa-light fa-democrat",
	"fa-light fa-desktop",
	"fa-light fa-desktop-alt",
	"fa-light fa-dewpoint",
	"fa-light fa-dharmachakra",
	"fa-light fa-diagnoses",
	"fa-light fa-diamond",
	"fa-light fa-dice",
	"fa-light fa-dice-d10",
	"fa-light fa-dice-d12",
	"fa-light fa-dice-d20",
	"fa-light fa-dice-d4",
	"fa-light fa-dice-d6",
	"fa-light fa-dice-d8",
	"fa-light fa-dice-five",
	"fa-light fa-dice-four",
	"fa-light fa-dice-one",
	"fa-light fa-dice-six",
	"fa-light fa-dice-three",
	"fa-light fa-dice-two",
	"fa-light fa-digging",
	"fa-light fa-digital-tachograph",
	"fa-light fa-diploma",
	"fa-light fa-directions",
	"fa-light fa-disc-drive",
	"fa-light fa-disease",
	"fa-light fa-divide",
	"fa-light fa-dizzy",
	"fa-light fa-dna",
	"fa-light fa-do-not-enter",
	"fa-light fa-dog",
	"fa-light fa-dog-leashed",
	"fa-light fa-dollar-sign",
	"fa-light fa-dolly",
	"fa-light fa-dolly-empty",
	"fa-light fa-dolly-flatbed",
	"fa-light fa-dolly-flatbed-alt",
	"fa-light fa-dolly-flatbed-empty",
	"fa-light fa-donate",
	"fa-light fa-door-closed",
	"fa-light fa-door-open",
	"fa-light fa-dot-circle",
	"fa-light fa-dove",
	"fa-light fa-download",
	"fa-light fa-drafting-compass",
	"fa-light fa-dragon",
	"fa-light fa-draw-circle",
	"fa-light fa-draw-polygon",
	"fa-light fa-draw-square",
	"fa-light fa-dreidel",
	"fa-light fa-drone",
	"fa-light fa-drone-alt",
	"fa-light fa-drum",
	"fa-light fa-drum-steelpan",
	"fa-light fa-drumstick",
	"fa-light fa-drumstick-bite",
	"fa-light fa-dryer",
	"fa-light fa-dryer-alt",
	"fa-light fa-duck",
	"fa-light fa-dumbbell",
	"fa-light fa-dumpster",
	"fa-light fa-dumpster-fire",
	"fa-light fa-dungeon",
	"fa-light fa-ear",
	"fa-light fa-ear-muffs",
	"fa-light fa-eclipse",
	"fa-light fa-eclipse-alt",
	"fa-light fa-edit",
	"fa-light fa-egg",
	"fa-light fa-egg-fried",
	"fa-light fa-eject",
	"fa-light fa-elephant",
	"fa-light fa-ellipsis-h",
	"fa-light fa-ellipsis-h-alt",
	"fa-light fa-ellipsis-v",
	"fa-light fa-ellipsis-v-alt",
	"fa-light fa-empty-set",
	"fa-light fa-engine-warning",
	"fa-light fa-envelope",
	"fa-light fa-envelope-open",
	"fa-light fa-envelope-open-dollar",
	"fa-light fa-envelope-open-text",
	"fa-light fa-envelope-square",
	"fa-light fa-equals",
	"fa-light fa-eraser",
	"fa-light fa-ethernet",
	"fa-light fa-euro-sign",
	"fa-light fa-exchange",
	"fa-light fa-exchange-alt",
	"fa-light fa-exclamation",
	"fa-light fa-exclamation-circle",
	"fa-light fa-exclamation-square",
	"fa-light fa-exclamation-triangle",
	"fa-light fa-expand",
	"fa-light fa-expand-alt",
	"fa-light fa-expand-arrows",
	"fa-light fa-expand-arrows-alt",
	"fa-light fa-expand-wide",
	"fa-light fa-external-link",
	"fa-light fa-external-link-alt",
	"fa-light fa-external-link-square",
	"fa-light fa-external-link-square-alt",
	"fa-light fa-eye",
	"fa-light fa-eye-dropper",
	"fa-light fa-eye-evil",
	"fa-light fa-eye-slash",
	"fa-light fa-fan",
	"fa-light fa-fan-table",
	"fa-light fa-farm",
	"fa-light fa-fast-backward",
	"fa-light fa-fast-forward",
	"fa-light fa-faucet",
	"fa-light fa-faucet-drip",
	"fa-light fa-fax",
	"fa-light fa-feather",
	"fa-light fa-feather-alt",
	"fa-light fa-female",
	"fa-light fa-field-hockey",
	"fa-light fa-fighter-jet",
	"fa-light fa-file",
	"fa-light fa-file-alt",
	"fa-light fa-file-archive",
	"fa-light fa-file-audio",
	"fa-light fa-file-certificate",
	"fa-light fa-file-chart-line",
	"fa-light fa-file-chart-pie",
	"fa-light fa-file-check",
	"fa-light fa-file-code",
	"fa-light fa-file-contract",
	"fa-light fa-file-csv",
	"fa-light fa-file-download",
	"fa-light fa-file-edit",
	"fa-light fa-file-excel",
	"fa-light fa-file-exclamation",
	"fa-light fa-file-export",
	"fa-light fa-file-image",
	"fa-light fa-file-import",
	"fa-light fa-file-invoice",
	"fa-light fa-file-invoice-dollar",
	"fa-light fa-file-medical",
	"fa-light fa-file-medical-alt",
	"fa-light fa-file-minus",
	"fa-light fa-file-music",
	"fa-light fa-file-pdf",
	"fa-light fa-file-plus",
	"fa-light fa-file-powerpoint",
	"fa-light fa-file-prescription",
	"fa-light fa-file-search",
	"fa-light fa-file-signature",
	"fa-light fa-file-spreadsheet",
	"fa-light fa-file-times",
	"fa-light fa-file-upload",
	"fa-light fa-file-user",
	"fa-light fa-file-video",
	"fa-light fa-file-word",
	"fa-light fa-files-medical",
	"fa-light fa-fill",
	"fa-light fa-fill-drip",
	"fa-light fa-film",
	"fa-light fa-film-alt",
	"fa-light fa-film-canister",
	"fa-light fa-filter",
	"fa-light fa-fingerprint",
	"fa-light fa-fire",
	"fa-light fa-fire-alt",
	"fa-light fa-fire-extinguisher",
	"fa-light fa-fire-smoke",
	"fa-light fa-fireplace",
	"fa-light fa-first-aid",
	"fa-light fa-fish",
	"fa-light fa-fish-cooked",
	"fa-light fa-fist-raised",
	"fa-light fa-flag",
	"fa-light fa-flag-alt",
	"fa-light fa-flag-checkered",
	"fa-light fa-flag-usa",
	"fa-light fa-flame",
	"fa-light fa-flashlight",
	"fa-light fa-flask",
	"fa-light fa-flask-poison",
	"fa-light fa-flask-potion",
	"fa-light fa-flower",
	"fa-light fa-flower-daffodil",
	"fa-light fa-flower-tulip",
	"fa-light fa-flushed",
	"fa-light fa-flute",
	"fa-light fa-flux-capacitor",
	"fa-light fa-fog",
	"fa-light fa-folder",
	"fa-light fa-folder-download",
	"fa-light fa-folder-minus",
	"fa-light fa-folder-open",
	"fa-light fa-folder-plus",
	"fa-light fa-folder-times",
	"fa-light fa-folder-tree",
	"fa-light fa-folder-upload",
	"fa-light fa-folders",
	"fa-light fa-font",
	"fa-light fa-font-case",
	"fa-light fa-football-ball",
	"fa-light fa-football-helmet",
	"fa-light fa-forklift",
	"fa-light fa-forward",
	"fa-light fa-fragile",
	"fa-light fa-french-fries",
	"fa-light fa-frog",
	"fa-light fa-frosty-head",
	"fa-light fa-frown",
	"fa-light fa-frown-open",
	"fa-light fa-function",
	"fa-light fa-funnel-dollar",
	"fa-light fa-futbol",
	"fa-light fa-galaxy",
	"fa-light fa-game-board",
	"fa-light fa-game-board-alt",
	"fa-light fa-game-console-handheld",
	"fa-light fa-gamepad",
	"fa-light fa-gamepad-alt",
	"fa-light fa-garage",
	"fa-light fa-garage-car",
	"fa-light fa-garage-open",
	"fa-light fa-gas-pump",
	"fa-light fa-gas-pump-slash",
	"fa-light fa-gavel",
	"fa-light fa-gem",
	"fa-light fa-genderless",
	"fa-light fa-ghost",
	"fa-light fa-gift",
	"fa-light fa-gift-card",
	"fa-light fa-gifts",
	"fa-light fa-gingerbread-man",
	"fa-light fa-glass",
	"fa-light fa-glass-champagne",
	"fa-light fa-glass-cheers",
	"fa-light fa-glass-citrus",
	"fa-light fa-glass-martini",
	"fa-light fa-glass-martini-alt",
	"fa-light fa-glass-whiskey",
	"fa-light fa-glass-whiskey-rocks",
	"fa-light fa-glasses",
	"fa-light fa-glasses-alt",
	"fa-light fa-globe",
	"fa-light fa-globe-africa",
	"fa-light fa-globe-americas",
	"fa-light fa-globe-asia",
	"fa-light fa-globe-europe",
	"fa-light fa-globe-snow",
	"fa-light fa-globe-stand",
	"fa-light fa-golf-ball",
	"fa-light fa-golf-club",
	"fa-light fa-gopuram",
	"fa-light fa-graduation-cap",
	"fa-light fa-gramophone",
	"fa-light fa-greater-than",
	"fa-light fa-greater-than-equal",
	"fa-light fa-grimace",
	"fa-light fa-grin",
	"fa-light fa-grin-alt",
	"fa-light fa-grin-beam",
	"fa-light fa-grin-beam-sweat",
	"fa-light fa-grin-hearts",
	"fa-light fa-grin-squint",
	"fa-light fa-grin-squint-tears",
	"fa-light fa-grin-stars",
	"fa-light fa-grin-tears",
	"fa-light fa-grin-tongue",
	"fa-light fa-grin-tongue-squint",
	"fa-light fa-grin-tongue-wink",
	"fa-light fa-grin-wink",
	"fa-light fa-grip-horizontal",
	"fa-light fa-grip-lines",
	"fa-light fa-grip-lines-vertical",
	"fa-light fa-grip-vertical",
	"fa-light fa-guitar",
	"fa-light fa-guitar-electric",
	"fa-light fa-guitars",
	"fa-light fa-h-square",
	"fa-light fa-h1",
	"fa-light fa-h2",
	"fa-light fa-h3",
	"fa-light fa-h4",
	"fa-light fa-hamburger",
	"fa-light fa-hammer",
	"fa-light fa-hammer-war",
	"fa-light fa-hamsa",
	"fa-light fa-hand-heart",
	"fa-light fa-hand-holding",
	"fa-light fa-hand-holding-box",
	"fa-light fa-hand-holding-heart",
	"fa-light fa-hand-holding-magic",
	"fa-light fa-hand-holding-medical",
	"fa-light fa-hand-holding-seedling",
	"fa-light fa-hand-holding-usd",
	"fa-light fa-hand-holding-water",
	"fa-light fa-hand-lizard",
	"fa-light fa-hand-middle-finger",
	"fa-light fa-hand-paper",
	"fa-light fa-hand-peace",
	"fa-light fa-hand-point-down",
	"fa-light fa-hand-point-left",
	"fa-light fa-hand-point-right",
	"fa-light fa-hand-point-up",
	"fa-light fa-hand-pointer",
	"fa-light fa-hand-receiving",
	"fa-light fa-hand-rock",
	"fa-light fa-hand-scissors",
	"fa-light fa-hand-sparkles",
	"fa-light fa-hand-spock",
	"fa-light fa-hands",
	"fa-light fa-hands-heart",
	"fa-light fa-hands-helping",
	"fa-light fa-hands-usd",
	"fa-light fa-hands-wash",
	"fa-light fa-handshake",
	"fa-light fa-handshake-alt",
	"fa-light fa-handshake-alt-slash",
	"fa-light fa-handshake-slash",
	"fa-light fa-hanukiah",
	"fa-light fa-hard-hat",
	"fa-light fa-hashtag",
	"fa-light fa-hat-chef",
	"fa-light fa-hat-cowboy",
	"fa-light fa-hat-cowboy-side",
	"fa-light fa-hat-santa",
	"fa-light fa-hat-winter",
	"fa-light fa-hat-witch",
	"fa-light fa-hat-wizard",
	"fa-light fa-hdd",
	"fa-light fa-head-side",
	"fa-light fa-head-side-brain",
	"fa-light fa-head-side-cough",
	"fa-light fa-head-side-cough-slash",
	"fa-light fa-head-side-headphones",
	"fa-light fa-head-side-mask",
	"fa-light fa-head-side-medical",
	"fa-light fa-head-side-virus",
	"fa-light fa-head-vr",
	"fa-light fa-heading",
	"fa-light fa-headphones",
	"fa-light fa-headphones-alt",
	"fa-light fa-headset",
	"fa-light fa-heart",
	"fa-light fa-heart-broken",
	"fa-light fa-heart-circle",
	"fa-light fa-heart-rate",
	"fa-light fa-heart-square",
	"fa-light fa-heartbeat",
	"fa-light fa-heat",
	"fa-light fa-helicopter",
	"fa-light fa-helmet-battle",
	"fa-light fa-hexagon",
	"fa-light fa-highlighter",
	"fa-light fa-hiking",
	"fa-light fa-hippo",
	"fa-light fa-history",
	"fa-light fa-hockey-mask",
	"fa-light fa-hockey-puck",
	"fa-light fa-hockey-sticks",
	"fa-light fa-holly-berry",
	"fa-light fa-home",
	"fa-light fa-home-alt",
	"fa-light fa-home-heart",
	"fa-light fa-home-lg",
	"fa-light fa-home-lg-alt",
	"fa-light fa-hood-cloak",
	"fa-light fa-horizontal-rule",
	"fa-light fa-horse",
	"fa-light fa-horse-head",
	"fa-light fa-horse-saddle",
	"fa-light fa-hospital",
	"fa-light fa-hospital-alt",
	"fa-light fa-hospital-symbol",
	"fa-light fa-hospital-user",
	"fa-light fa-hospitals",
	"fa-light fa-hot-tub",
	"fa-light fa-hotdog",
	"fa-light fa-hotel",
	"fa-light fa-hourglass",
	"fa-light fa-hourglass-end",
	"fa-light fa-hourglass-half",
	"fa-light fa-hourglass-start",
	"fa-light fa-house",
	"fa-light fa-house-damage",
	"fa-light fa-house-day",
	"fa-light fa-house-flood",
	"fa-light fa-house-leave",
	"fa-light fa-house-night",
	"fa-light fa-house-return",
	"fa-light fa-house-signal",
	"fa-light fa-house-user",
	"fa-light fa-hryvnia",
	"fa-light fa-humidity",
	"fa-light fa-hurricane",
	"fa-light fa-i-cursor",
	"fa-light fa-ice-cream",
	"fa-light fa-ice-skate",
	"fa-light fa-icicles",
	"fa-light fa-icons",
	"fa-light fa-icons-alt",
	"fa-light fa-id-badge",
	"fa-light fa-id-card",
	"fa-light fa-id-card-alt",
	"fa-light fa-igloo",
	"fa-light fa-image",
	"fa-light fa-image-polaroid",
	"fa-light fa-images",
	"fa-light fa-inbox",
	"fa-light fa-inbox-in",
	"fa-light fa-inbox-out",
	"fa-light fa-indent",
	"fa-light fa-industry",
	"fa-light fa-industry-alt",
	"fa-light fa-infinity",
	"fa-light fa-info",
	"fa-light fa-info-circle",
	"fa-light fa-info-square",
	"fa-light fa-inhaler",
	"fa-light fa-integral",
	"fa-light fa-intersection",
	"fa-light fa-inventory",
	"fa-light fa-island-tropical",
	"fa-light fa-italic",
	"fa-light fa-jack-o-lantern",
	"fa-light fa-jedi",
	"fa-light fa-joint",
	"fa-light fa-journal-whills",
	"fa-light fa-joystick",
	"fa-light fa-jug",
	"fa-light fa-kaaba",
	"fa-light fa-kazoo",
	"fa-light fa-kerning",
	"fa-light fa-key",
	"fa-light fa-key-skeleton",
	"fa-light fa-keyboard",
	"fa-light fa-keynote",
	"fa-light fa-khanda",
	"fa-light fa-kidneys",
	"fa-light fa-kiss",
	"fa-light fa-kiss-beam",
	"fa-light fa-kiss-wink-heart",
	"fa-light fa-kite",
	"fa-light fa-kiwi-bird",
	"fa-light fa-knife-kitchen",
	"fa-light fa-lambda",
	"fa-light fa-lamp",
	"fa-light fa-lamp-desk",
	"fa-light fa-lamp-floor",
	"fa-light fa-landmark",
	"fa-light fa-landmark-alt",
	"fa-light fa-language",
	"fa-light fa-laptop",
	"fa-light fa-laptop-code",
	"fa-light fa-laptop-house",
	"fa-light fa-laptop-medical",
	"fa-light fa-lasso",
	"fa-light fa-laugh",
	"fa-light fa-laugh-beam",
	"fa-light fa-laugh-squint",
	"fa-light fa-laugh-wink",
	"fa-light fa-layer-group",
	"fa-light fa-layer-minus",
	"fa-light fa-layer-plus",
	"fa-light fa-leaf",
	"fa-light fa-leaf-heart",
	"fa-light fa-leaf-maple",
	"fa-light fa-leaf-oak",
	"fa-light fa-lemon",
	"fa-light fa-less-than",
	"fa-light fa-less-than-equal",
	"fa-light fa-level-down",
	"fa-light fa-level-down-alt",
	"fa-light fa-level-up",
	"fa-light fa-level-up-alt",
	"fa-light fa-life-ring",
	"fa-light fa-light-ceiling",
	"fa-light fa-light-switch",
	"fa-light fa-light-switch-off",
	"fa-light fa-light-switch-on",
	"fa-light fa-lightbulb",
	"fa-light fa-lightbulb-dollar",
	"fa-light fa-lightbulb-exclamation",
	"fa-light fa-lightbulb-on",
	"fa-light fa-lightbulb-slash",
	"fa-light fa-lights-holiday",
	"fa-light fa-line-columns",
	"fa-light fa-line-height",
	"fa-light fa-link",
	"fa-light fa-lips",
	"fa-light fa-lira-sign",
	"fa-light fa-list",
	"fa-light fa-list-alt",
	"fa-light fa-list-music",
	"fa-light fa-list-ol",
	"fa-light fa-list-ul",
	"fa-light fa-location",
	"fa-light fa-location-arrow",
	"fa-light fa-location-circle",
	"fa-light fa-location-slash",
	"fa-light fa-lock",
	"fa-light fa-lock-alt",
	"fa-light fa-lock-open",
	"fa-light fa-lock-open-alt",
	"fa-light fa-long-arrow-alt-down",
	"fa-light fa-long-arrow-alt-left",
	"fa-light fa-long-arrow-alt-right",
	"fa-light fa-long-arrow-alt-up",
	"fa-light fa-long-arrow-down",
	"fa-light fa-long-arrow-left",
	"fa-light fa-long-arrow-right",
	"fa-light fa-long-arrow-up",
	"fa-light fa-loveseat",
	"fa-light fa-low-vision",
	"fa-light fa-luchador",
	"fa-light fa-luggage-cart",
	"fa-light fa-lungs",
	"fa-light fa-lungs-virus",
	"fa-light fa-mace",
	"fa-light fa-magic",
	"fa-light fa-magnet",
	"fa-light fa-mail-bulk",
	"fa-light fa-mailbox",
	"fa-light fa-male",
	"fa-light fa-mandolin",
	"fa-light fa-map",
	"fa-light fa-map-marked",
	"fa-light fa-map-marked-alt",
	"fa-light fa-map-marker",
	"fa-light fa-map-marker-alt",
	"fa-light fa-map-marker-alt-slash",
	"fa-light fa-map-marker-check",
	"fa-light fa-map-marker-edit",
	"fa-light fa-map-marker-exclamation",
	"fa-light fa-map-marker-minus",
	"fa-light fa-map-marker-plus",
	"fa-light fa-map-marker-question",
	"fa-light fa-map-marker-slash",
	"fa-light fa-map-marker-smile",
	"fa-light fa-map-marker-times",
	"fa-light fa-map-pin",
	"fa-light fa-map-signs",
	"fa-light fa-marker",
	"fa-light fa-mars",
	"fa-light fa-mars-double",
	"fa-light fa-mars-stroke",
	"fa-light fa-mars-stroke-h",
	"fa-light fa-mars-stroke-v",
	"fa-light fa-mask",
	"fa-light fa-meat",
	"fa-light fa-medal",
	"fa-light fa-medkit",
	"fa-light fa-megaphone",
	"fa-light fa-meh",
	"fa-light fa-meh-blank",
	"fa-light fa-meh-rolling-eyes",
	"fa-light fa-memory",
	"fa-light fa-menorah",
	"fa-light fa-mercury",
	"fa-light fa-meteor",
	"fa-light fa-microchip",
	"fa-light fa-microphone",
	"fa-light fa-microphone-alt",
	"fa-light fa-microphone-alt-slash",
	"fa-light fa-microphone-slash",
	"fa-light fa-microphone-stand",
	"fa-light fa-microscope",
	"fa-light fa-microwave",
	"fa-light fa-mind-share",
	"fa-light fa-minus",
	"fa-light fa-minus-circle",
	"fa-light fa-minus-hexagon",
	"fa-light fa-minus-octagon",
	"fa-light fa-minus-square",
	"fa-light fa-mistletoe",
	"fa-light fa-mitten",
	"fa-light fa-mobile",
	"fa-light fa-mobile-alt",
	"fa-light fa-mobile-android",
	"fa-light fa-mobile-android-alt",
	"fa-light fa-money-bill",
	"fa-light fa-money-bill-alt",
	"fa-light fa-money-bill-wave",
	"fa-light fa-money-bill-wave-alt",
	"fa-light fa-money-check",
	"fa-light fa-money-check-alt",
	"fa-light fa-money-check-edit",
	"fa-light fa-money-check-edit-alt",
	"fa-light fa-monitor-heart-rate",
	"fa-light fa-monkey",
	"fa-light fa-monument",
	"fa-light fa-moon",
	"fa-light fa-moon-cloud",
	"fa-light fa-moon-stars",
	"fa-light fa-mortar-pestle",
	"fa-light fa-mosque",
	"fa-light fa-motorcycle",
	"fa-light fa-mountain",
	"fa-light fa-mountains",
	"fa-light fa-mouse",
	"fa-light fa-mouse-alt",
	"fa-light fa-mouse-pointer",
	"fa-light fa-mp3-player",
	"fa-light fa-mug",
	"fa-light fa-mug-hot",
	"fa-light fa-mug-marshmallows",
	"fa-light fa-mug-tea",
	"fa-light fa-music",
	"fa-light fa-music-alt",
	"fa-light fa-music-alt-slash",
	"fa-light fa-music-slash",
	"fa-light fa-narwhal",
	"fa-light fa-network-wired",
	"fa-light fa-neuter",
	"fa-light fa-newspaper",
	"fa-light fa-not-equal",
	"fa-light fa-notes-medical",
	"fa-light fa-object-group",
	"fa-light fa-object-ungroup",
	"fa-light fa-octagon",
	"fa-light fa-oil-can",
	"fa-light fa-oil-temp",
	"fa-light fa-om",
	"fa-light fa-omega",
	"fa-light fa-ornament",
	"fa-light fa-otter",
	"fa-light fa-outdent",
	"fa-light fa-outlet",
	"fa-light fa-oven",
	"fa-light fa-overline",
	"fa-light fa-page-break",
	"fa-light fa-pager",
	"fa-light fa-paint-brush",
	"fa-light fa-paint-brush-alt",
	"fa-light fa-paint-roller",
	"fa-light fa-palette",
	"fa-light fa-pallet",
	"fa-light fa-pallet-alt",
	"fa-light fa-paper-plane",
	"fa-light fa-paperclip",
	"fa-light fa-parachute-box",
	"fa-light fa-paragraph",
	"fa-light fa-paragraph-rtl",
	"fa-light fa-parking",
	"fa-light fa-parking-circle",
	"fa-light fa-parking-circle-slash",
	"fa-light fa-parking-slash",
	"fa-light fa-passport",
	"fa-light fa-pastafarianism",
	"fa-light fa-paste",
	"fa-light fa-pause",
	"fa-light fa-pause-circle",
	"fa-light fa-paw",
	"fa-light fa-paw-alt",
	"fa-light fa-paw-claws",
	"fa-light fa-peace",
	"fa-light fa-pegasus",
	"fa-light fa-pen",
	"fa-light fa-pen-alt",
	"fa-light fa-pen-fancy",
	"fa-light fa-pen-nib",
	"fa-light fa-pen-square",
	"fa-light fa-pencil",
	"fa-light fa-pencil-alt",
	"fa-light fa-pencil-paintbrush",
	"fa-light fa-pencil-ruler",
	"fa-light fa-pennant",
	"fa-light fa-people-arrows",
	"fa-light fa-people-carry",
	"fa-light fa-pepper-hot",
	"fa-light fa-percent",
	"fa-light fa-percentage",
	"fa-light fa-person-booth",
	"fa-light fa-person-carry",
	"fa-light fa-person-dolly",
	"fa-light fa-person-dolly-empty",
	"fa-light fa-person-sign",
	"fa-light fa-phone",
	"fa-light fa-phone-alt",
	"fa-light fa-phone-laptop",
	"fa-light fa-phone-office",
	"fa-light fa-phone-plus",
	"fa-light fa-phone-rotary",
	"fa-light fa-phone-slash",
	"fa-light fa-phone-square",
	"fa-light fa-phone-square-alt",
	"fa-light fa-phone-volume",
	"fa-light fa-photo-video",
	"fa-light fa-pi",
	"fa-light fa-piano",
	"fa-light fa-piano-keyboard",
	"fa-light fa-pie",
	"fa-light fa-pig",
	"fa-light fa-piggy-bank",
	"fa-light fa-pills",
	"fa-light fa-pizza",
	"fa-light fa-pizza-slice",
	"fa-light fa-place-of-worship",
	"fa-light fa-plane",
	"fa-light fa-plane-alt",
	"fa-light fa-plane-arrival",
	"fa-light fa-plane-departure",
	"fa-light fa-plane-slash",
	"fa-light fa-planet-moon",
	"fa-light fa-planet-ringed",
	"fa-light fa-play",
	"fa-light fa-play-circle",
	"fa-light fa-plug",
	"fa-light fa-plus",
	"fa-light fa-plus-circle",
	"fa-light fa-plus-hexagon",
	"fa-light fa-plus-octagon",
	"fa-light fa-plus-square",
	"fa-light fa-podcast",
	"fa-light fa-podium",
	"fa-light fa-podium-star",
	"fa-light fa-police-box",
	"fa-light fa-poll",
	"fa-light fa-poll-h",
	"fa-light fa-poll-people",
	"fa-light fa-poo",
	"fa-light fa-poo-storm",
	"fa-light fa-poop",
	"fa-light fa-popcorn",
	"fa-light fa-portal-enter",
	"fa-light fa-portal-exit",
	"fa-light fa-portrait",
	"fa-light fa-pound-sign",
	"fa-light fa-power-off",
	"fa-light fa-pray",
	"fa-light fa-praying-hands",
	"fa-light fa-prescription",
	"fa-light fa-prescription-bottle",
	"fa-light fa-prescription-bottle-alt",
	"fa-light fa-presentation",
	"fa-light fa-print",
	"fa-light fa-print-search",
	"fa-light fa-print-slash",
	"fa-light fa-procedures",
	"fa-light fa-project-diagram",
	"fa-light fa-projector",
	"fa-light fa-pump-medical",
	"fa-light fa-pump-soap",
	"fa-light fa-pumpkin",
	"fa-light fa-puzzle-piece",
	"fa-light fa-qrcode",
	"fa-light fa-question",
	"fa-light fa-question-circle",
	"fa-light fa-question-square",
	"fa-light fa-quidditch",
	"fa-light fa-quote-left",
	"fa-light fa-quote-right",
	"fa-light fa-quran",
	"fa-light fa-rabbit",
	"fa-light fa-rabbit-fast",
	"fa-light fa-racquet",
	"fa-light fa-radar",
	"fa-light fa-radiation",
	"fa-light fa-radiation-alt",
	"fa-light fa-radio",
	"fa-light fa-radio-alt",
	"fa-light fa-rainbow",
	"fa-light fa-raindrops",
	"fa-light fa-ram",
	"fa-light fa-ramp-loading",
	"fa-light fa-random",
	"fa-light fa-raygun",
	"fa-light fa-receipt",
	"fa-light fa-record-vinyl",
	"fa-light fa-rectangle-landscape",
	"fa-light fa-rectangle-portrait",
	"fa-light fa-rectangle-wide",
	"fa-light fa-recycle",
	"fa-light fa-redo",
	"fa-light fa-redo-alt",
	"fa-light fa-refrigerator",
	"fa-light fa-registered",
	"fa-light fa-remove-format",
	"fa-light fa-repeat",
	"fa-light fa-repeat-1",
	"fa-light fa-repeat-1-alt",
	"fa-light fa-repeat-alt",
	"fa-light fa-reply",
	"fa-light fa-reply-all",
	"fa-light fa-republican",
	"fa-light fa-restroom",
	"fa-light fa-retweet",
	"fa-light fa-retweet-alt",
	"fa-light fa-ribbon",
	"fa-light fa-ring",
	"fa-light fa-rings-wedding",
	"fa-light fa-road",
	"fa-light fa-robot",
	"fa-light fa-rocket",
	"fa-light fa-rocket-launch",
	"fa-light fa-route",
	"fa-light fa-route-highway",
	"fa-light fa-route-interstate",
	"fa-light fa-router",
	"fa-light fa-rss",
	"fa-light fa-rss-square",
	"fa-light fa-ruble-sign",
	"fa-light fa-ruler",
	"fa-light fa-ruler-combined",
	"fa-light fa-ruler-horizontal",
	"fa-light fa-ruler-triangle",
	"fa-light fa-ruler-vertical",
	"fa-light fa-running",
	"fa-light fa-rupee-sign",
	"fa-light fa-rv",
	"fa-light fa-sack",
	"fa-light fa-sack-dollar",
	"fa-light fa-sad-cry",
	"fa-light fa-sad-tear",
	"fa-light fa-salad",
	"fa-light fa-sandwich",
	"fa-light fa-satellite",
	"fa-light fa-satellite-dish",
	"fa-light fa-sausage",
	"fa-light fa-save",
	"fa-light fa-sax-hot",
	"fa-light fa-saxophone",
	"fa-light fa-scalpel",
	"fa-light fa-scalpel-path",
	"fa-light fa-scanner",
	"fa-light fa-scanner-image",
	"fa-light fa-scanner-keyboard",
	"fa-light fa-scanner-touchscreen",
	"fa-light fa-scarecrow",
	"fa-light fa-scarf",
	"fa-light fa-school",
	"fa-light fa-screwdriver",
	"fa-light fa-scroll",
	"fa-light fa-scroll-old",
	"fa-light fa-scrubber",
	"fa-light fa-scythe",
	"fa-light fa-sd-card",
	"fa-light fa-search",
	"fa-light fa-search-dollar",
	"fa-light fa-search-location",
	"fa-light fa-search-minus",
	"fa-light fa-search-plus",
	"fa-light fa-seedling",
	"fa-light fa-send-back",
	"fa-light fa-send-backward",
	"fa-light fa-sensor",
	"fa-light fa-sensor-alert",
	"fa-light fa-sensor-fire",
	"fa-light fa-sensor-on",
	"fa-light fa-sensor-smoke",
	"fa-light fa-server",
	"fa-light fa-shapes",
	"fa-light fa-share",
	"fa-light fa-share-all",
	"fa-light fa-share-alt",
	"fa-light fa-share-alt-square",
	"fa-light fa-share-square",
	"fa-light fa-sheep",
	"fa-light fa-shekel-sign",
	"fa-light fa-shield",
	"fa-light fa-shield-alt",
	"fa-light fa-shield-check",
	"fa-light fa-shield-cross",
	"fa-light fa-shield-virus",
	"fa-light fa-ship",
	"fa-light fa-shipping-fast",
	"fa-light fa-shipping-timed",
	"fa-light fa-shish-kebab",
	"fa-light fa-shoe-prints",
	"fa-light fa-shopping-bag",
	"fa-light fa-shopping-basket",
	"fa-light fa-shopping-cart",
	"fa-light fa-shovel",
	"fa-light fa-shovel-snow",
	"fa-light fa-shower",
	"fa-light fa-shredder",
	"fa-light fa-shuttle-van",
	"fa-light fa-shuttlecock",
	"fa-light fa-sickle",
	"fa-light fa-sigma",
	"fa-light fa-sign",
	"fa-light fa-sign-in",
	"fa-light fa-sign-in-alt",
	"fa-light fa-sign-language",
	"fa-light fa-sign-out",
	"fa-light fa-sign-out-alt",
	"fa-light fa-signal",
	"fa-light fa-signal-1",
	"fa-light fa-signal-2",
	"fa-light fa-signal-3",
	"fa-light fa-signal-4",
	"fa-light fa-signal-alt",
	"fa-light fa-signal-alt-1",
	"fa-light fa-signal-alt-2",
	"fa-light fa-signal-alt-3",
	"fa-light fa-signal-alt-slash",
	"fa-light fa-signal-slash",
	"fa-light fa-signal-stream",
	"fa-light fa-signature",
	"fa-light fa-sim-card",
	"fa-light fa-sink",
	"fa-light fa-siren",
	"fa-light fa-siren-on",
	"fa-light fa-sitemap",
	"fa-light fa-skating",
	"fa-light fa-skeleton",
	"fa-light fa-ski-jump",
	"fa-light fa-ski-lift",
	"fa-light fa-skiing",
	"fa-light fa-skiing-nordic",
	"fa-light fa-skull",
	"fa-light fa-skull-cow",
	"fa-light fa-skull-crossbones",
	"fa-light fa-slash",
	"fa-light fa-sledding",
	"fa-light fa-sleigh",
	"fa-light fa-sliders-h",
	"fa-light fa-sliders-h-square",
	"fa-light fa-sliders-v",
	"fa-light fa-sliders-v-square",
	"fa-light fa-smile",
	"fa-light fa-smile-beam",
	"fa-light fa-smile-plus",
	"fa-light fa-smile-wink",
	"fa-light fa-smog",
	"fa-light fa-smoke",
	"fa-light fa-smoking",
	"fa-light fa-smoking-ban",
	"fa-light fa-sms",
	"fa-light fa-snake",
	"fa-light fa-snooze",
	"fa-light fa-snow-blowing",
	"fa-light fa-snowboarding",
	"fa-light fa-snowflake",
	"fa-light fa-snowflakes",
	"fa-light fa-snowman",
	"fa-light fa-snowmobile",
	"fa-light fa-snowplow",
	"fa-light fa-soap",
	"fa-light fa-socks",
	"fa-light fa-solar-panel",
	"fa-light fa-solar-system",
	"fa-light fa-sort",
	"fa-light fa-sort-alpha-down",
	"fa-light fa-sort-alpha-down-alt",
	"fa-light fa-sort-alpha-up",
	"fa-light fa-sort-alpha-up-alt",
	"fa-light fa-sort-alt",
	"fa-light fa-sort-amount-down",
	"fa-light fa-sort-amount-down-alt",
	"fa-light fa-sort-amount-up",
	"fa-light fa-sort-amount-up-alt",
	"fa-light fa-sort-circle",
	"fa-light fa-sort-circle-down",
	"fa-light fa-sort-circle-up",
	"fa-light fa-sort-down",
	"fa-light fa-sort-numeric-down",
	"fa-light fa-sort-numeric-down-alt",
	"fa-light fa-sort-numeric-up",
	"fa-light fa-sort-numeric-up-alt",
	"fa-light fa-sort-shapes-down",
	"fa-light fa-sort-shapes-down-alt",
	"fa-light fa-sort-shapes-up",
	"fa-light fa-sort-shapes-up-alt",
	"fa-light fa-sort-size-down",
	"fa-light fa-sort-size-down-alt",
	"fa-light fa-sort-size-up",
	"fa-light fa-sort-size-up-alt",
	"fa-light fa-sort-up",
	"fa-light fa-soup",
	"fa-light fa-spa",
	"fa-light fa-space-shuttle",
	"fa-light fa-space-station-moon",
	"fa-light fa-space-station-moon-alt",
	"fa-light fa-spade",
	"fa-light fa-sparkles",
	"fa-light fa-speaker",
	"fa-light fa-speakers",
	"fa-light fa-spell-check",
	"fa-light fa-spider",
	"fa-light fa-spider-black-widow",
	"fa-light fa-spider-web",
	"fa-light fa-spinner",
	"fa-light fa-spinner-third",
	"fa-light fa-splotch",
	"fa-light fa-spray-can",
	"fa-light fa-sprinkler",
	"fa-light fa-square",
	"fa-light fa-square-full",
	"fa-light fa-square-root",
	"fa-light fa-square-root-alt",
	"fa-light fa-squirrel",
	"fa-light fa-staff",
	"fa-light fa-stamp",
	"fa-light fa-star",
	"fa-light fa-star-and-crescent",
	"fa-light fa-star-christmas",
	"fa-light fa-star-exclamation",
	"fa-light fa-star-half",
	"fa-light fa-star-half-alt",
	"fa-light fa-star-of-david",
	"fa-light fa-star-of-life",
	"fa-light fa-star-shooting",
	"fa-light fa-starfighter",
	"fa-light fa-starfighter-alt",
	"fa-light fa-stars",
	"fa-light fa-starship",
	"fa-light fa-starship-freighter",
	"fa-light fa-steak",
	"fa-light fa-steering-wheel",
	"fa-light fa-step-backward",
	"fa-light fa-step-forward",
	"fa-light fa-stethoscope",
	"fa-light fa-sticky-note",
	"fa-light fa-stocking",
	"fa-light fa-stomach",
	"fa-light fa-stop",
	"fa-light fa-stop-circle",
	"fa-light fa-stopwatch",
	"fa-light fa-stopwatch-20",
	"fa-light fa-store",
	"fa-light fa-store-alt",
	"fa-light fa-store-alt-slash",
	"fa-light fa-store-slash",
	"fa-light fa-stream",
	"fa-light fa-street-view",
	"fa-light fa-stretcher",
	"fa-light fa-strikethrough",
	"fa-light fa-stroopwafel",
	"fa-light fa-subscript",
	"fa-light fa-subway",
	"fa-light fa-suitcase",
	"fa-light fa-suitcase-rolling",
	"fa-light fa-sun",
	"fa-light fa-sun-cloud",
	"fa-light fa-sun-dust",
	"fa-light fa-sun-haze",
	"fa-light fa-sunglasses",
	"fa-light fa-sunrise",
	"fa-light fa-sunset",
	"fa-light fa-superscript",
	"fa-light fa-surprise",
	"fa-light fa-swatchbook",
	"fa-light fa-swimmer",
	"fa-light fa-swimming-pool",
	"fa-light fa-sword",
	"fa-light fa-sword-laser",
	"fa-light fa-sword-laser-alt",
	"fa-light fa-swords",
	"fa-light fa-swords-laser",
	"fa-light fa-synagogue",
	"fa-light fa-sync",
	"fa-light fa-sync-alt",
	"fa-light fa-syringe",
	"fa-light fa-table",
	"fa-light fa-table-tennis",
	"fa-light fa-tablet",
	"fa-light fa-tablet-alt",
	"fa-light fa-tablet-android",
	"fa-light fa-tablet-android-alt",
	"fa-light fa-tablet-rugged",
	"fa-light fa-tablets",
	"fa-light fa-tachometer",
	"fa-light fa-tachometer-alt",
	"fa-light fa-tachometer-alt-average",
	"fa-light fa-tachometer-alt-fast",
	"fa-light fa-tachometer-alt-fastest",
	"fa-light fa-tachometer-alt-slow",
	"fa-light fa-tachometer-alt-slowest",
	"fa-light fa-tachometer-average",
	"fa-light fa-tachometer-fast",
	"fa-light fa-tachometer-fastest",
	"fa-light fa-tachometer-slow",
	"fa-light fa-tachometer-slowest",
	"fa-light fa-taco",
	"fa-light fa-tag",
	"fa-light fa-tags",
	"fa-light fa-tally",
	"fa-light fa-tanakh",
	"fa-light fa-tape",
	"fa-light fa-tasks",
	"fa-light fa-tasks-alt",
	"fa-light fa-taxi",
	"fa-light fa-teeth",
	"fa-light fa-teeth-open",
	"fa-light fa-telescope",
	"fa-light fa-temperature-down",
	"fa-light fa-temperature-frigid",
	"fa-light fa-temperature-high",
	"fa-light fa-temperature-hot",
	"fa-light fa-temperature-low",
	"fa-light fa-temperature-up",
	"fa-light fa-tenge",
	"fa-light fa-tennis-ball",
	"fa-light fa-terminal",
	"fa-light fa-text",
	"fa-light fa-text-height",
	"fa-light fa-text-size",
	"fa-light fa-text-width",
	"fa-light fa-th",
	"fa-light fa-th-large",
	"fa-light fa-th-list",
	"fa-light fa-theater-masks",
	"fa-light fa-thermometer",
	"fa-light fa-thermometer-empty",
	"fa-light fa-thermometer-full",
	"fa-light fa-thermometer-half",
	"fa-light fa-thermometer-quarter",
	"fa-light fa-thermometer-three-quarters",
	"fa-light fa-theta",
	"fa-light fa-thumbs-down",
	"fa-light fa-thumbs-up",
	"fa-light fa-thumbtack",
	"fa-light fa-thunderstorm",
	"fa-light fa-thunderstorm-moon",
	"fa-light fa-thunderstorm-sun",
	"fa-light fa-ticket",
	"fa-light fa-ticket-alt",
	"fa-light fa-tilde",
	"fa-light fa-times",
	"fa-light fa-times-circle",
	"fa-light fa-times-hexagon",
	"fa-light fa-times-octagon",
	"fa-light fa-times-square",
	"fa-light fa-tint",
	"fa-light fa-tint-slash",
	"fa-light fa-tire",
	"fa-light fa-tire-flat",
	"fa-light fa-tire-pressure-warning",
	"fa-light fa-tire-rugged",
	"fa-light fa-tired",
	"fa-light fa-toggle-off",
	"fa-light fa-toggle-on",
	"fa-light fa-toilet",
	"fa-light fa-toilet-paper",
	"fa-light fa-toilet-paper-alt",
	"fa-light fa-toilet-paper-slash",
	"fa-light fa-tombstone",
	"fa-light fa-tombstone-alt",
	"fa-light fa-toolbox",
	"fa-light fa-tools",
	"fa-light fa-tooth",
	"fa-light fa-toothbrush",
	"fa-light fa-torah",
	"fa-light fa-torii-gate",
	"fa-light fa-tornado",
	"fa-light fa-tractor",
	"fa-light fa-trademark",
	"fa-light fa-traffic-cone",
	"fa-light fa-traffic-light",
	"fa-light fa-traffic-light-go",
	"fa-light fa-traffic-light-slow",
	"fa-light fa-traffic-light-stop",
	"fa-light fa-trailer",
	"fa-light fa-train",
	"fa-light fa-tram",
	"fa-light fa-transgender",
	"fa-light fa-transgender-alt",
	"fa-light fa-transporter",
	"fa-light fa-transporter-1",
	"fa-light fa-transporter-2",
	"fa-light fa-transporter-3",
	"fa-light fa-transporter-empty",
	"fa-light fa-trash",
	"fa-light fa-trash-alt",
	"fa-light fa-trash-restore",
	"fa-light fa-trash-restore-alt",
	"fa-light fa-trash-undo",
	"fa-light fa-trash-undo-alt",
	"fa-light fa-treasure-chest",
	"fa-light fa-tree",
	"fa-light fa-tree-alt",
	"fa-light fa-tree-christmas",
	"fa-light fa-tree-decorated",
	"fa-light fa-tree-large",
	"fa-light fa-tree-palm",
	"fa-light fa-trees",
	"fa-light fa-triangle",
	"fa-light fa-triangle-music",
	"fa-light fa-trophy",
	"fa-light fa-trophy-alt",
	"fa-light fa-truck",
	"fa-light fa-truck-container",
	"fa-light fa-truck-couch",
	"fa-light fa-truck-loading",
	"fa-light fa-truck-monster",
	"fa-light fa-truck-moving",
	"fa-light fa-truck-pickup",
	"fa-light fa-truck-plow",
	"fa-light fa-truck-ramp",
	"fa-light fa-trumpet",
	"fa-light fa-tshirt",
	"fa-light fa-tty",
	"fa-light fa-turkey",
	"fa-light fa-turntable",
	"fa-light fa-turtle",
	"fa-light fa-tv",
	"fa-light fa-tv-alt",
	"fa-light fa-tv-music",
	"fa-light fa-tv-retro",
	"fa-light fa-typewriter",
	"fa-light fa-ufo",
	"fa-light fa-ufo-beam",
	"fa-light fa-umbrella",
	"fa-light fa-umbrella-beach",
	"fa-light fa-underline",
	"fa-light fa-undo",
	"fa-light fa-undo-alt",
	"fa-light fa-unicorn",
	"fa-light fa-union",
	"fa-light fa-universal-access",
	"fa-light fa-university",
	"fa-light fa-unlink",
	"fa-light fa-unlock",
	"fa-light fa-unlock-alt",
	"fa-light fa-upload",
	"fa-light fa-usb-drive",
	"fa-light fa-usd-circle",
	"fa-light fa-usd-square",
	"fa-light fa-user",
	"fa-light fa-user-alien",
	"fa-light fa-user-alt",
	"fa-light fa-user-alt-slash",
	"fa-light fa-user-astronaut",
	"fa-light fa-user-chart",
	"fa-light fa-user-check",
	"fa-light fa-user-circle",
	"fa-light fa-user-clock",
	"fa-light fa-user-cog",
	"fa-light fa-user-cowboy",
	"fa-light fa-user-crown",
	"fa-light fa-user-edit",
	"fa-light fa-user-friends",
	"fa-light fa-user-graduate",
	"fa-light fa-user-hard-hat",
	"fa-light fa-user-headset",
	"fa-light fa-user-injured",
	"fa-light fa-user-lock",
	"fa-light fa-user-md",
	"fa-light fa-user-md-chat",
	"fa-light fa-user-minus",
	"fa-light fa-user-music",
	"fa-light fa-user-ninja",
	"fa-light fa-user-nurse",
	"fa-light fa-user-plus",
	"fa-light fa-user-robot",
	"fa-light fa-user-secret",
	"fa-light fa-user-shield",
	"fa-light fa-user-slash",
	"fa-light fa-user-tag",
	"fa-light fa-user-tie",
	"fa-light fa-user-times",
	"fa-light fa-user-unlock",
	"fa-light fa-user-visor",
	"fa-light fa-users",
	"fa-light fa-users-class",
	"fa-light fa-users-cog",
	"fa-light fa-users-crown",
	"fa-light fa-users-medical",
	"fa-light fa-users-slash",
	"fa-light fa-utensil-fork",
	"fa-light fa-utensil-knife",
	"fa-light fa-utensil-spoon",
	"fa-light fa-utensils",
	"fa-light fa-utensils-alt",
	"fa-light fa-vacuum",
	"fa-light fa-vacuum-robot",
	"fa-light fa-value-absolute",
	"fa-light fa-vector-square",
	"fa-light fa-venus",
	"fa-light fa-venus-double",
	"fa-light fa-venus-mars",
	"fa-light fa-vest",
	"fa-light fa-vest-patches",
	"fa-light fa-vhs",
	"fa-light fa-vial",
	"fa-light fa-vials",
	"fa-light fa-video",
	"fa-light fa-video-plus",
	"fa-light fa-video-slash",
	"fa-light fa-vihara",
	"fa-light fa-violin",
	"fa-light fa-virus",
	"fa-light fa-virus-slash",
	"fa-light fa-viruses",
	"fa-light fa-voicemail",
	"fa-light fa-volcano",
	"fa-light fa-volleyball-ball",
	"fa-light fa-volume",
	"fa-light fa-volume-down",
	"fa-light fa-volume-mute",
	"fa-light fa-volume-off",
	"fa-light fa-volume-slash",
	"fa-light fa-volume-up",
	"fa-light fa-vote-nay",
	"fa-light fa-vote-yea",
	"fa-light fa-vr-cardboard",
	"fa-light fa-wagon-covered",
	"fa-light fa-walker",
	"fa-light fa-walkie-talkie",
	"fa-light fa-walking",
	"fa-light fa-wallet",
	"fa-light fa-wand",
	"fa-light fa-wand-magic",
	"fa-light fa-warehouse",
	"fa-light fa-warehouse-alt",
	"fa-light fa-washer",
	"fa-light fa-watch",
	"fa-light fa-watch-calculator",
	"fa-light fa-watch-fitness",
	"fa-light fa-water",
	"fa-light fa-water-lower",
	"fa-light fa-water-rise",
	"fa-light fa-wave-sine",
	"fa-light fa-wave-square",
	"fa-light fa-wave-triangle",
	"fa-light fa-waveform",
	"fa-light fa-waveform-path",
	"fa-light fa-webcam",
	"fa-light fa-webcam-slash",
	"fa-light fa-weight",
	"fa-light fa-weight-hanging",
	"fa-light fa-whale",
	"fa-light fa-wheat",
	"fa-light fa-wheelchair",
	"fa-light fa-whistle",
	"fa-light fa-wifi",
	"fa-light fa-wifi-1",
	"fa-light fa-wifi-2",
	"fa-light fa-wifi-slash",
	"fa-light fa-wind",
	"fa-light fa-wind-turbine",
	"fa-light fa-wind-warning",
	"fa-light fa-window",
	"fa-light fa-window-alt",
	"fa-light fa-window-close",
	"fa-light fa-window-frame",
	"fa-light fa-window-frame-open",
	"fa-light fa-window-maximize",
	"fa-light fa-window-minimize",
	"fa-light fa-window-restore",
	"fa-light fa-windsock",
	"fa-light fa-wine-bottle",
	"fa-light fa-wine-glass",
	"fa-light fa-wine-glass-alt",
	"fa-light fa-won-sign",
	"fa-light fa-wreath",
	"fa-light fa-wrench",
	"fa-light fa-x-ray",
	"fa-light fa-yen-sign",
	"fa-light fa-yin-yang",
];
